<div class="mainpanel">
	<mat-toolbar color="primary">School Eligibility</mat-toolbar>
	<p class="verticalMargin">
		This is where you set schools eligibility for each award.
		Check the checkbox next to each school you want to be eligible.
	</p>

	<div *ngIf="ViewReady === false && loading === false" fxLayout="column" fxLayoutAlign="start center">
		<button mat-raised-button [color]="'primary'" type="button" (click)="sortSchoolsByName(true)">Get Schools Sorted By Name</button>
		<button mat-raised-button [color]="'primary'" type="button" (click)="sortSchoolsByName(false)">Get Schools Sorted By Number</button>
	</div>

	<form [formGroup]="eligibilityForm" (ngSubmit)="submit(eligibilityForm)" novalidate *ngIf="ViewReady">
		<div class="verticalMargin" fxLayout="row" fxLayoutAlign="space-around center">
			<button mat-raised-button [color]="'primary'" type="button" (click)="SelectAll()">Select All</button>
			<button mat-raised-button [color]="'accent'" type="submit">Submit</button>
		</div>
		<div formArrayName="EligibilityList">
			<table>
				<thead>
					<tr>
						<th>School Number</th>
						<th>School Name</th>
						<th>Eligible</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let e of eligibilityForm.get('EligibilityList').controls; let i = index;" [formGroupName]="i">
						<td>
							<span *ngIf="!e.value.InSchoolGroup">{{e.value.SchoolNumber}}</span>
							<span *ngIf="e.value.InSchoolGroup">{{e.value.SchoolNumberList}}</span>
						</td>
						<td>{{e.value.SchoolName}}</td>
						<td>
							<mat-checkbox formControlName="IsChecked"></mat-checkbox>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</form>

</div>

